/* FORSA by LINTEL PDP: gallery (dots/thumbs), native set picker (real units: filter, or filter + 2 cartridges), brand cart drawer after add, review sliders */
(function () {
  var tr = document.querySelector('[data-fs-track]'), dots = document.querySelector('[data-fs-dots]'), thumbs = document.querySelector('[data-fs-thumbs]');
  function imgs() { return tr ? Array.prototype.slice.call(tr.children) : []; }
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (dots) dots.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (dots) { dots.innerHTML = Array(imgs().length + 1).join('<span></span>'); dots.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); }); }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  document.querySelectorAll('.fs-pk input').forEach(function (r) {
    r.addEventListener('change', function () { document.querySelectorAll('.fs-pk').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); }); });
  });
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; if (window.FS) window.FS.openCart(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
  var form = document.querySelector('form[data-fs-add]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      var vid = form.querySelector('[data-fs-vid]'), pk = form.querySelector('input[name="fs-pack"]:checked');
      var items = [{ id: +vid.value, quantity: 1 }];
      if (pk && pk.value === 'b' && vid.dataset.cart) items.push({ id: +vid.dataset.cart, quantity: 2 });
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }
  document.querySelectorAll('[data-fs-rs]').forEach(function (c) {
    var t = c.querySelector('.fs-rs__track');
    c.querySelectorAll('.fs-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth, behavior: 'smooth' }); }); });
  });
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the FS brand cart drawer ===== */
(function () {
  if (window.__fs_atc) return; window.__fs_atc = 1;
  function open() { if (window.FS && window.FS.openCart) return window.FS.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
